import dayjs from 'dayjs';

interface Checkin {
  created_at: string;
  late_status: string;
  meal_allowance: number;
  exemption_applied: boolean;
  ip_address: string;
  user_agent: string;
}

interface ListViewProps {
  checkins: Checkin[];
}

const ListView = ({ checkins }: ListViewProps) => {
  return (
    <div>
      {checkins.map(checkin => {
        const date = dayjs(checkin.created_at);
        
        let statusClass = 'text-green-600';
        let statusText = 'On time';
        let statusEmoji = '✅';
        let penaltyText = 'No penalty';
        
        // Calculate time in minutes for close call detection
        const timeInMinutes = date.hour() * 60 + date.minute();
        
        if (checkin.late_status === 'perfect_on_time') {
          statusClass = 'text-green-800';
          statusText = 'Perfect (Before 8:00)';
          statusEmoji = '🌟';
        } else if (checkin.late_status === 'on_time') {
          if (timeInMinutes >= 480 && timeInMinutes < 490) {
            // Between 8:00 and 8:10 - close call
            statusClass = 'text-amber-600';
            statusText = 'Close call';
            statusEmoji = '😅';
          }
        } else if (checkin.late_status === 'late_10') {
          statusClass = 'text-amber-600';
          statusText = 'Late (8:10-8:30)';
          statusEmoji = '⏰';
          penaltyText = checkin.exemption_applied ? 
            'Exemption applied - No penalty' : 
            '10% penalty applied';
        } else if (checkin.late_status === 'late_15') {
          statusClass = 'text-red-600';
          statusText = 'Late (after 8:30)';
          statusEmoji = '⚠️';
          penaltyText = '15% penalty applied';
        }

        return (
          <div key={checkin.created_at} className="p-2 sm:p-4 border-b border-gray-200 last:border-0">
            <div className="font-semibold text-gray-800 mb-0.5 sm:mb-1 text-sm sm:text-base">
              {date.format('dddd, MMMM D, YYYY')}
            </div>
            <div className="text-gray-600 mb-1 sm:mb-2 text-xs sm:text-sm">
              <span className="text-blue-500">⏱</span> Check-in Time: {date.format('h:mm A')}
            </div>
            <div className={`flex items-center gap-1 sm:gap-2 font-medium ${statusClass} text-xs sm:text-sm`}>
              <span className="text-xl inline-block">{statusEmoji}</span> {statusText} - {penaltyText}
            </div>
            {checkin.exemption_applied && (
              <div className="flex items-center gap-1 sm:gap-2 mt-1 sm:mt-2 text-blue-600">
                <span className="text-base sm:text-xl">🎉</span> Weekly exemption used
              </div>
            )}
            {checkin.meal_allowance > 0 && (
              <div className="flex items-center gap-1 sm:gap-2 mt-1 sm:mt-2 text-blue-600">
                <span className="text-base sm:text-xl">🍽️</span> Meal allowance: {checkin.meal_allowance} THB
              </div>
            )}
            <div className="bg-gray-50 mt-1 sm:mt-2 p-1 sm:p-2 rounded text-xs sm:text-sm">
              <span className="text-gray-500 font-medium">IP:</span>{' '}
              <span className="break-all">{checkin.ip_address || 'Not recorded'}</span>
              <br />
              <span className="text-gray-500 font-medium">Device:</span>{' '}
              <span className="break-all">
                {checkin.user_agent ? `${checkin.user_agent.substring(0, 50)}...` : 'Not recorded'}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ListView; 